'use strict';

var PricingDepartureDatesChartViewport = function PricingDepartureDatesChartViewport(ChartViewport, chartGroups, chartXAxis, chartSimpleBars) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./ScalesViewport');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('departureDateMoment').asViewport();
    var m1Bars = chartSimpleBars('m1');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, m1Bars, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
PricingDepartureDatesChartViewport.$inject = ['ChartViewport', 'ChartElementsGroup', 'ChartElementsXAxis', 'ChartElementsSimpleBars'];
module.exports = PricingDepartureDatesChartViewport;